'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _emojione = require('emojione');

var _emojione2 = _interopRequireDefault(_emojione);

var _htmlReactParser = require('html-react-parser');

var _htmlReactParser2 = _interopRequireDefault(_htmlReactParser);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _replace = require('lodash/replace');

var _replace2 = _interopRequireDefault(_replace);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    shortname: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  })).isRequired,
  changeTone: _propTypes2.default.func.isRequired,
  tone: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  modifierStyle: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
};

var defaultProps = {
  style: {},
  modifierStyle: {}
};

function EmojiModifiers(_ref) {
  var modifiers = _ref.modifiers,
      changeTone = _ref.changeTone,
      tone = _ref.tone,
      style = _ref.style,
      modifierStyle = _ref.modifierStyle;

  return _react2.default.createElement(
    'header',
    { style: _getStyles2.default.header(style) },
    _react2.default.createElement(
      'div',
      { style: _getStyles2.default.modifiers(modifierStyle) },
      _react2.default.createElement(
        'div',
        {
          onClick: function onClick() {
            return changeTone('tone0');
          },
          className: 'modifier',
          style: _getStyles2.default.modifier(tone === 'tone0')
        },
        _react2.default.createElement(
          'svg',
          { width: '50px', height: '50px', viewBox: '0 0 50 50', className: 'emojione' },
          _react2.default.createElement('circle', { id: 'circle', fill: '#FFDD67', cx: '25', cy: '25', r: '25' })
        )
      ),
      (0, _map2.default)(modifiers, function (modifier) {
        var title = (0, _replace2.default)(modifier.title, /:/g, '');

        return _react2.default.createElement(
          'div',
          {
            style: _getStyles2.default.modifier(title === tone, modifierStyle),
            key: 'emoji-' + modifier.shortname,
            onClick: function onClick() {
              return changeTone(title);
            },
            className: 'modifier'
          },
          (0, _htmlReactParser2.default)(_emojione2.default.toImage(modifier.shortname))
        );
      })
    ),
    _react2.default.createElement(
      'a',
      {
        style: _styles2.default.attributionLink,
        href: 'https://www.emojione.com/',
        target: '_blank',
        rel: 'noopener noreferrer'
      },
      'Emoji by EmojiOne'
    ),
    _react2.default.createElement(_radium.Style, {
      scopeSelector: '.modifier',
      rules: {
        '.emojione': {
          width: 'inherit',
          height: 'inherit'
        }
      }
    })
  );
}

EmojiModifiers.propTypes = propTypes;
EmojiModifiers.defaultProps = defaultProps;

exports.default = (0, _radium2.default)(EmojiModifiers);
module.exports = exports.default;